<template>
  <div class="tickets">
    <button
      type="button"
      :class="{
        isCanceled:
          props.limitedExpressTicket.ticketing_status == '03' ||
          props.limitedExpressTicket.ticketing_status == '04' ||
          props.isOnPastPage,
      }"
      :onclick="goToMyTicketPage"
    >
      <div class="row bg">
        <!-- 車型ごとに画像を使い分け -->
        <div
          class="img"
          :class="{
            vse: carType == 'VSE',
            mse: carType == 'MSE',
            gse: carType == 'GSE',
            exe: carType == 'EXE',
          }"
        ></div>
      </div>
      <div class="row">
        <div class="text">
          <span class="name">
            {{ isDPTicket ? "（契・旅）特急整理票" : "ロマンスカー特急券" }}
          </span>

          <!-- 乗車日・発駅・発車時刻 -->
          <span class="departure-date">
            {{ props.limitedExpressTicket.boarding_date.replace(/-/g, "/") }}
            {{ props.limitedExpressTicket.from_station.name }}
            {{ displayMfittTime(props.limitedExpressTicket.departure_at) }}発
          </span>

          <!-- 人数 サルーンの場合は区分なしで合計人数のみ表示 -->
          <span
            v-if="props.limitedExpressTicket.saloon_count == null"
            class="number"
            >おとな{{ props.limitedExpressTicket.adult_count }}名/こども{{
              props.limitedExpressTicket.child_count
            }}名</span
          >
          <span v-else class="number">
            {{
              props.limitedExpressTicket.adult_count +
              props.limitedExpressTicket.child_count
            }}名
          </span>

          <!-- 購入時のみ、号車・座席番号表示(過去チケットは対象外) -->
          <div
            v-if="
              props.limitedExpressTicket.ticketing_status == '02' &&
              !props.isOnPastPage
            "
            class="seat-list"
          >
            <div v-for="(car, index) in displaySeatArray" :key="index">
              <div class="car">{{ car.car_number }}号車</div>
              <div class="container">
                <div
                  v-for="(seat, seatIndex) in car.display_number_array"
                  :key="seatIndex"
                  class="seat"
                >
                  {{ seat }}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="row">
        <img
          v-if="props.limitedExpressTicket.ticketing_status == '01'"
          :src="require(`@/assets/img/icon/svg/icon-reservation.svg`)"
        />
        <img
          v-else-if="
            props.limitedExpressTicket.ticketing_status == '02' && isUsedCoupon
          "
          :src="require(`@/assets/img/icon/svg/icon-exchange.svg`)"
        />
        <img
          v-else-if="props.limitedExpressTicket.ticketing_status == '02'"
          :src="require(`@/assets/img/icon/svg/icon-buy.svg`)"
        />
        <img
          v-else-if="props.limitedExpressTicket.ticketing_status == '03'"
          :src="require(`@/assets/img/icon/svg/icon-canceled.svg`)"
        />
        <img
          v-else-if="
            props.limitedExpressTicket.ticketing_status == '04' && isUsedCoupon
          "
          :src="require(`@/assets/img/icon/svg/icon-canceled-2.svg`)"
        />
        <img
          v-else-if="
            props.limitedExpressTicket.ticketing_status == '04' && isUsedAlipay
          "
          :src="require(`@/assets/img/icon/svg/icon-refund-applied.svg`)"
        />
        <img
          v-else-if="props.limitedExpressTicket.ticketing_status == '04'"
          :src="require(`@/assets/img/icon/svg/icon-refunded.svg`)"
        />
        <!-- 画像表示がないので余白調整 -->
        <div v-else class="no-status-img" />
      </div>
      <div v-if="isReservationWithPurchaseDeadline" class="row warning-row">
        <span class="warning-block">
          <span class="warning-text">購入が未完了です</span>
          <br class="warning-break" />
          購入期限：
          {{
            displayMfittDateTime(props.limitedExpressTicket.auto_canceled_at)
          }}
        </span>
      </div>
    </button>
  </div>
</template>

<script>
import mfittService from "@/services/MFITT";

export default {
  name: "MFITTResevationCard",
  props: {
    limitedExpressTicket: {
      type: Object,
      required: true,
    },
    // 過去チケットページでは背景グレーにするため、isOnPastPage=trueにする
    isOnPastPage: {
      type: Boolean,
      required: false,
      default: false,
    },
  },
  setup(props) {
    const carType = props.limitedExpressTicket.train.cars_formation.name.substr(
      0,
      3
    );

    const displaySeatArray = mfittService.generateDisplaySeatArray(
      props.limitedExpressTicket.seats
    );

    const isUsedCoupon = mfittService.isCouponsCommodityCode(
      props.limitedExpressTicket.commodity_code
    );

    const isUsedAlipay = mfittService.isAlipayCommodityCode(
      props.limitedExpressTicket.commodity_code
    );

    const isDPTicket = props.limitedExpressTicket.app_code == "DP";

    // ticketing_status '01': 予約済み
    const isReservationStatus =
      props.limitedExpressTicket.ticketing_status == "01";
    // auto_canceled_at: 自動取消日時（nullable string）
    const hasPurchaseDeadline = !!props.limitedExpressTicket.auto_canceled_at;
    const isCurrentTicket = !props.isOnPastPage;
    const isReservationWithPurchaseDeadline =
      isReservationStatus && hasPurchaseDeadline && isCurrentTicket;

    const goToMyTicketPage = () => {
      if (isUsedCoupon) {
        mfittService.goToMyTicketWithCoupon(props.limitedExpressTicket.id);
      } else {
        mfittService.goToMyTicket(props.limitedExpressTicket.id);
      }
    };

    return {
      props,
      carType,
      displaySeatArray,
      isUsedCoupon,
      goToMyTicketPage,
      isDPTicket,
      isUsedAlipay,
      isReservationWithPurchaseDeadline,
    };
  },
};
</script>

<style lang="scss">
.tickets {
  margin: 6px 0 !important;
}

.tickets button {
  position: relative;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: stretch;
  width: 100%;
  height: auto;
  padding: 0;
  border: 1px solid #e0e0e0;
  border-radius: 6px;
  font-size: 14px;
  font-weight: bold;
  background-color: #ffffff;
  color: #000000;
}

.tickets button.isCanceled {
  background-color: #f2f2f2 !important;
  color: #6e6e6e;
}

.tickets button .row .no-status-img {
  width: 38px;
  height: 38px;
  margin: 0;
  padding: 0;
}

.tickets button .row.bg {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  display: flex;
  align-items: center;
  width: 70px;
  background-color: #f6ece0;
  border-radius: 6px 0 0 6px;
}

.tickets button .row:first-of-type .img {
  flex-grow: 1;
  height: 70px;
  background-position: center center;
  background-repeat: no-repeat;
  background-size: cover;
  width: 70px;
  margin: 0;
  padding: 0;
  line-height: 0;
}

/* 車型ごとに画像を使い分け */
.tickets button .row:first-of-type .vse {
  background-image: url("~@/assets/img/material/btn_sentaku_vse_f3.jpg");
}

.tickets button .row:first-of-type .mse {
  background-image: url("~@/assets/img/material/btn_sentaku_mse_f3.jpg");
}

.tickets button .row:first-of-type .gse {
  background-image: url("~@/assets/img/material/btn_sentaku_gse_f3.jpg");
}

.tickets button .row:first-of-type .exe {
  background-image: url("~@/assets/img/material/btn_sentaku_exe_f3.jpg");
}

.tickets button .row:nth-of-type(2) {
  width: calc(100% - 75px - 60px);
  margin-left: 70px;
}

.tickets button .row .text {
  text-align: left;
  font-weight: normal;
  margin-bottom: 8px;
  padding-left: 10px;
}

.tickets button .row .text span {
  display: block;
}

.tickets button .row span.name {
  font-size: 15px;
  font-weight: bold;
  margin-top: 12px;
}

.tickets button .row span.departure-date {
  font-size: 13px;
  font-weight: bold;
  color: #777777;
  margin-top: 6px;
}

.tickets button .row span.number {
  font-size: 12px;
  font-weight: bold;
  color: #777777;
  margin-top: 4px;
}

.tickets button .row:nth-child(3) {
  width: auto;
  align-self: flex-end;
  padding: 0 9px 9px 0;
  line-height: 0;
}

.tickets button .row:nth-child(3) img {
  width: 38px;
  height: 38px;
  margin: 0;
  padding: 0;
}

.tickets button .row .seat-list {
  width: 100%;
  margin: 6px 0 0;
}

.tickets button .row .seat-list .car {
  float: left;
  font-size: 12px;
  font-weight: bold;
  text-align: left;
  color: #777777;
  width: 42px;
  margin-top: 3px;
}

.tickets button .row .seat-list .container {
  display: flex;
  justify-content: flex-start;
  flex-wrap: wrap;
  margin-bottom: 2px;
}

.tickets button .row .seat-list .container .seat {
  flex-basis: 24px;
  border: 1px solid #bcbcbc;
  border-radius: 4px;
  padding: 2px 4px;
  margin: 1px 2px 1px 0;
  font-size: 12px;
  color: #333333;
  text-align: center;
  font-weight: bold;
}

/* 横幅が320px以下の場合に適用するスタイル */
@media (max-width: 320px) {
  .tickets button .row:first-of-type .img {
    width: 65px;
  }

  .tickets button .row:nth-of-type(2) {
    width: calc(100% - 70px - 60px);
    margin-bottom: 6px;
  }

  .tickets button .row span.name {
    font-size: 14px;
  }

  .tickets button .row span.date {
    font-size: 12px;
  }

  .tickets button .row span.number {
    font-size: 11px;
  }

  .radio input[type="radio"] + .radio-label:before {
    margin-right: 2px;
  }
}
.tickets button .row.warning-row {
  width: calc(100% - 80px);
  margin-left: 80px;
  padding: 0 9px 9px 0;
}

.warning-block {
  display: block;
  font-size: 12px;
  font-weight: bold;
  background: #fff2ec;
  color: #ed2323;
  text-align: left;
  padding: 2px 4px;
}
.warning-break {
  display: none;
}
.warning-text {
  display: inline;
}
.warning-text::after {
  content: "\3000";
}
@media (max-width: 364px) {
  .warning-text::after {
    content: "";
  }
  .warning-break {
    display: block;
  }
}
</style>
